import { render, staticRenderFns } from "./graphLegend.vue?vue&type=template&id=c3822c34&scoped=true&"
import script from "./graphLegend.vue?vue&type=script&lang=js&"
export * from "./graphLegend.vue?vue&type=script&lang=js&"
import style0 from "./graphLegend.vue?vue&type=style&index=0&id=c3822c34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3822c34",
  null
  
)

export default component.exports